// extracted by mini-css-extract-plugin
export default {"searchContainer":"DashboardSearch-module__searchContainer--LEgAY","actions":"DashboardSearch-module__actions--IpaWx"};